<app-window-title [closable]="true"
                  [title]="'Patient IDs - ' + patientName"
                  (closed)="dialogRef.close()"></app-window-title>

<div class="patient-ids-dialog-content fx-col"  mat-dialog-content>
  
  <div class="patient-ids-header fx-row fx-jc-start fx-ai-center"  >
    <mat-icon class="header-icon">
      badge
    </mat-icon>
    <span class="header-text">
      Facility(s) & Patient ID(s)
    </span>
  </div>

  <div class="patient-ids-list">
    <div *ngFor="let id of patientIDs; trackBy: trackByPatientId"
         class="patient-id-entry">
      <div class="facility-info">
        <mat-icon class="facility-icon">
          local_hospital
        </mat-icon>
        <span class="facility-name">
          {{id.facility}}
        </span>
      </div>
      <div class="patient-id-badge">
        {{id.value}}
      </div>
    </div>
  </div>

  <div *ngIf="!patientIDs || patientIDs.length === 0"
       class="no-ids-message">
    <mat-icon class="no-ids-icon">
      info
    </mat-icon>
    <span>No patient IDs available</span>
  </div>
</div>
